export const VIEW_TYPES = [
    'grid',
    'kanban',
    'gallery',
    'calendar',
    'form',
    'timeline',
    'gantt',
    'chart',
    'pivot',
    'list',
    'map',
    'orgChart',
];
//# sourceMappingURL=view-types.js.map